import { Node, Editor } from 'slate';

export function getPrompt({ editor }) {
  const texts = editor.children?.map((node) => {
    return node.type === 'p' ? `${Node.string(node)}` : '';
  });

  const highlighted = editor.selection
    ? Editor.string(editor, editor.selection)
    : null;

  const prompt = highlighted ? highlighted.trim() : texts.join(' ').trim();

  return { prompt, isHighlighted: !!highlighted };
}
